var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-card"},[_c(_vm.image,{tag:"component",staticClass:"game-icon"}),_c('div',{staticClass:"game-info"},[_c('span',{staticClass:"game-name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"game-value"},[_c('span',{staticClass:"currency-icon"},[_vm._v("C$")]),_c('span',[_vm._v(_vm._s(_vm.value))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }